<template>
  <v-container>
    <v-card class="mx-auto mt-5" max-width="800">
      <v-card-title class="headline">
        {{ $t('Meine Kurse') }}
      </v-card-title>
      <v-card-subtitle>
        {{ $t('Bitte wählen Sie einen Kurs aus.') }}
      </v-card-subtitle>
      <v-divider></v-divider>
      
      <v-list v-if="courses && courses.length > 0">
        <v-list-item
          v-for="course in courses"
          :key="course.id || course._id"
          @click="selectCourse(course)"
          link
        >
          <v-list-item-header>
            <v-list-item-title>{{ course.name || course.title }}</v-list-item-title>
            <v-list-item-subtitle v-if="course.id || course._id">ID: {{ course.id || course._id }}</v-list-item-subtitle>
          </v-list-item-header>
          <template v-slot:append>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-list-item>
      </v-list>
      
      <v-card-text v-else-if="loading" class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-card-text>
      
      <v-card-text v-else class="text-center">
        {{ $t('Keine passenden Kurse (TSMM) gefunden.') }}
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import APIService from '@/services/APIService';
import { isMesskursCourse } from '@/tools/utils';

export default {
  name: 'UserCourseSelectionView',
  setup() {
    const store = useStore();
    const router = useRouter();
    const courses = ref([]);
    const loading = ref(false);

    const fetchCourses = async () => {
      loading.value = true;
      try {
        const userId = store.state.user?.id;
        if (!userId) {
          console.error("No user ID found for fetching courses");
          return;
        }

        const userCourses = await APIService.getUserCourses(userId);
        console.log("User courses:", userCourses);

        // Erkenne Messkurs über Tag "Messkurs", fallback über comment (beides case-insensitive)
        let filtered = [];
        if (Array.isArray(userCourses)) {
          filtered = userCourses.filter(course => isMesskursCourse(course));
        } else if (userCourses && userCourses.results) {
           filtered = userCourses.results.filter(course => isMesskursCourse(course));
        }
        courses.value = filtered;
      } catch (error) {
        console.error("Error fetching user courses:", error);
      } finally {
        loading.value = false;
      }
    };

    const selectCourse = (course) => {
      const courseId = course.id || course._id;
      store.dispatch('updateCourse', course);
      router.push({ name: 'UserSessionSelection', params: { courseId: courseId } });
    };

    onMounted(() => {
      fetchCourses();
    });

    return {
      courses,
      loading,
      selectCourse
    };
  }
};
</script>
